function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "log-out-04",
    clipPath: "url(#clip0_487_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.5 6L16.5 9M16.5 9L13.5 12M16.5 9L6.75 9M11.25 3.15303C10.2939 2.57871 9.18393 2.25 8 2.25C4.41015 2.25 1.5 5.27208 1.5 9C1.5 12.7279 4.41015 15.75 8 15.75C9.18393 15.75 10.2939 15.4213 11.25 14.847",
    stroke: "#F36464",
    style: {
      stroke: "#F36464",
      stroke: "color(display-p3 0.9514 0.3904 0.3904)",
      strokeOpacity: 1
    },
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_1277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.49dee51333cdfcaa4cbb95a78ca258dd.svg";
export { ForwardRef as ReactComponent };